import Indonesia from '../Assets/Imgs/Indonesia.svg';
import Vietnam from '../Assets/Imgs/Vietnam.svg';
import Thailand from '../Assets/Imgs/Thailand.svg';
import Philippines from '../Assets/Imgs/Philippines.svg';
import Malaysia from '../Assets/Imgs/Malaysia.svg';
import Singapore from '../Assets/Imgs/Singapore.svg';

export const header = 'Choose a Country or Region';

const Countries_Details = [
  {
    name: 'Indonesia',
    icon: Indonesia
  },
  {
    name: 'Vietnam',
    icon: Vietnam
  },
  {
    name: 'Thailand',
    icon: Thailand
  },
  {
    name: 'Philippines',
    icon: Philippines
  },
  {
    name: 'Malaysia',
    icon: Malaysia
  },
  // {
  //   name: 'Singapore',
  //   icon: Singapore
  // }
]

export default Countries_Details;